import { useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import PerformanceCard from '../PerformanceCard';
import styles from './conversionTime.module.scss';

export default function ConversionTimeContent() {
  const { conversionTime } = useSelector((state) => state.DashboardSlice);
  const { icon, mdn, max, min, percentage_status, variation } = conversionTime;

  return (
    <>
      <PerformanceCard.Summary
        value={mdn}
        percentageStatus={percentage_status}
        tendency={variation}
        icon={icon}
      />

      <Box className={styles.separator} />

      <PerformanceCard.Content>
        <Box className={styles.conversionTimeValues}>
          <Box className={styles.item}>
            <Text className={styles.itemLabel}>Max:</Text>
            <Text className={`${styles.itemValue} ${styles.itemValueMax}`}>
              {max}
            </Text>
          </Box>
          <Box className={styles.item}>
            <Text className={styles.itemLabel}>Min:</Text>
            <Text className={`${styles.itemValue} ${styles.itemValueMin}`}>
              {min}
            </Text>
          </Box>
        </Box>
      </PerformanceCard.Content>
    </>
  );
}
